// extracted by mini-css-extract-plugin
export var button = "_c4-2";
export var iconWrapper = "_c4-0";
export var investigatingIcon = "_c4-1";